import { useSelector } from "react-redux";
import { setUser } from "../../reducers/userReducer";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";

export default function UserIntro() {
  const username = useSelector(setUser)
  return (
    <div className="user">
      <h2 style={{fontWeight:"bold"}}>Hey {username},</h2>
      <h6> There are 8 billion people on the planet, but you are unique and outstanding among the rest. We are so glad to have you on Hanchor.</h6>
      <h1 style={{fontWeight:"bold"}}>Let's Go! <Link to='/home'><BsArrowRightCircleFill color="#F39237" size="35px" style={{cursor:"pointer"}}/></Link></h1>
    </div>
  )
}
